module.exports = __webpack_public_path__ + "files/06cf4a4310fa34873950ed3d9caa1320.png";